import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Store } from '@ngrx/store';
import { UserRoleService } from 'services/api/user-role.service';
import {
  saveUserRoles,
  updateSelectedUserRoleByOrganizationId,
  saveUserLanguage,
} from './user-info/user-info.actions';
import { Lang, LANG_MAP } from '../../core/transloco/transloco-root.module';
import { UserInfoEffects } from './user-info/user-info.effects';

@Injectable({ providedIn: 'root' })
export class StoreService {
  constructor(
    private readonly userRoleService: UserRoleService,
    private readonly store: Store,
    private readonly authService: AuthService,
  ) {}

  refreshOrganizationStore() {
    this.userRoleService.getUserRoles().subscribe((userUserRoles) => {
      if (userUserRoles.length > 0) {
        this.store.dispatch(
          saveUserRoles({
            userRoles: userUserRoles,
          }),
        );

        this.authService.user$.subscribe((user) => {
          const userMainOrg =
            user?.['https://mazdaeur.com/roles/user']?.employerDomain?.ref;

          // Try to restore the previously selected organization
          const savedOrgId = this.getSelectedOrganizationId();
          const savedRole = savedOrgId
            ? userUserRoles.find((role) => role.organizationId === savedOrgId)
            : null;

          const userRole =
            savedRole ??
            userUserRoles.find(
              (role) => role.organization?.code === userMainOrg,
            ) ??
            userUserRoles[0];

          if (userRole) {
            this.store.dispatch(
              updateSelectedUserRoleByOrganizationId({
                organizationId: userRole.organizationId,
              }),
            );
          }

          const userLanguageCode =
            user?.['https://mazdaeur.com/roles/user']?.user_metadata.language;

          let userLang: Lang = Lang.EN_GB;
          if (userLanguageCode) {
            userLang =
              LANG_MAP[userLanguageCode as keyof typeof LANG_MAP] ?? Lang.EN_GB;
          }
          this.store.dispatch(saveUserLanguage({ language: userLang }));

          // TODO: request user's rolePrivileges
          // TODO: create userRolePrivileges in store
        });
      }
    });
  }

  private getSelectedOrganizationId(): string | null {
    try {
      return localStorage.getItem(UserInfoEffects.SELECTED_ORG_KEY);
    } catch (error) {
      console.error(
        'Failed to retrieve selected organization from localStorage:',
        error,
      );
      return null;
    }
  }
}
